<template>
  <b-modal
    id="package-category-modal"
    no-enforce-focus
    size="lg"
    @shown="onShown"
    @hidden="onHidden"
  >
    <template v-slot:modal-title>
      {{ trans('category') }}
      <small v-if="!!package_category" class="text-muted ml-2">
        #{{ package_category.id }}
      </small>
    </template>

    <b-row>
      <b-col class="col-9">
        <b-form-group :label="trans('name')">
          <b-form-input v-model="name" :disabled="busy" />
        </b-form-group>
      </b-col>
      <b-col class="col-3">
        <b-form-group>
          <label>
            {{ trans('visible') }}
            <small class="text-muted" :title="trans('microsite_visible_about')" v-b-tooltip.hover>
              <i class="fa fa-fw fa-info-circle"></i>
            </small>
          </label>
          <b-form-checkbox switch :label="trans('microsite_visible_about')" v-model="visible">
            {{ trans(visible ? 'yes' : 'no') }}
          </b-form-checkbox>
        </b-form-group>
      </b-col>
    </b-row>
    <br/>
    <p>{{ trans('microsite_display') }}</p>
    <b-row>
      <b-col>
        <b-form-group :label="trans('package_short_description')">
          <b-form-input v-model="short_description" maxlength="150" :disabled="busy" />
        </b-form-group>
      </b-col>
      <b-col>
        <b-form-group :label="trans('button_text')">
          <b-input v-model="button_text" :placeholder="trans('learn_more')" :disabled="busy" />
        </b-form-group>
      </b-col>
    </b-row>
    <br/>

    <calendar-config
      v-if="visible"
      :organization="organization"
      :package_category="package_category"
      v-model="meta"
      :disabled="busy"
    ></calendar-config>
    <br/>

    <b-form-group :label="trans('package_long_description')">
      <html-textarea
        :organization="organization"
        show-insert-form-document
        v-model="description"
        :disabled="busy"
      ></html-textarea>
    </b-form-group>

    <b-form-group :label="trans('image')">
      <image-tab
        :organization="organization"
        type="hero"
        :image_url="image_url"
        @image_url="image_url = $event"
        only-image
        return-compressed-image
      ></image-tab>
    </b-form-group>

    <p v-if="busy">
      <i class="fa fa-fw fa-circle-notch fa-spin"></i>
      {{ trans('please_wait') }}
    </p>
    <p v-if="error" class="text-danger">
      {{ error }}
    </p>

    <template v-slot:modal-footer>
      <b-row class="w-100">
        <b-col v-if="!!package_category">
          <delete-button variant="outline-danger" @confirm="onDelete" :disabled="busy">
            {{ trans('delete') }}
          </delete-button>
        </b-col>
        <b-col class="col-auto">
          <b-button variant="light" @click="$bvModal.hide('package-category-modal')">
            {{ trans('cancel') }}
          </b-button>
          <b-button variant="primary" @click="onSave" :disabled="busy || !canSave">
            {{ trans(package_category ? 'save' : 'create') }}
          </b-button>
        </b-col>
      </b-row>
    </template>
  </b-modal>
</template>

<script>
  import HtmlTextarea from './../../../common/components/HtmlTextarea'
  import DeleteButton from './../../../common/components/DeleteConfirmButton'
  import ImageTab from './../template/BlockImageTabComponent'
  import CalendarConfig from './PackageCategoryCalendarConfig'

  export default {
    props: {
      organization: Object,
      package_category: Object,
      reloadAfterSave: {
        type: Boolean,
        default: false,
      },
    },
    components: {
      HtmlTextarea,
      ImageTab,
      DeleteButton,
      CalendarConfig,
    },
    data() {
      return {
        trans: trans,
        lang: lang,
        busy: false,
        error: null,
        name: null,
        visible: true,
        description: null,
        short_description: null,
        button_text: null,
        image_url: null,
        meta: null,
        visible: false,
      }
    },
    computed: {
      canSave() {
        return !this.busy && !!this.name
      },
    },
    methods: {
      onDelete() {
        this.busy = true
        this.error = null
        let url = `/organization/${this.organization.id}/package_category/${this.package_category.id}`
        axios.delete(url)
        .then(response => {
          this.busy = false
          this.$emit('deleted')
          this.$bvModal.hide('package-category-modal')
        })
        .catch(error => {
          this.busy = false
          this.error = _.errorFromAjax(error)
        })
      },
      onSave() {
        this.busy = true
        this.error = null

        let url = `/organization/${this.organization.id}/package_category`
        if (this.package_category) url += `/${this.package_category.id}`
        const method = this.package_category ? 'patch' : 'post'
        const data = {
          name: this.name,
          visible: this.visible,
          description: this.description,
          short_description: this.short_description,
          button_text: this.button_text,
          image_url: this.image_url,
          meta: this.meta,
        }

        axios[method](url, data)
        .then(response => {
          if (this.reloadAfterSave) {
            window.location.reload()
            return
          }
          this.busy = false
          this.$emit('saved')
          this.$bvModal.hide('package-category-modal')
        })
        .catch(error => {
          this.busy = false
          this.error = _.errorFromAjax(error)
        })
      },
      onShown() {
        if (this.package_category) {
          this.name = this.package_category.name
          this.visible = this.package_category.visible
          this.description = this.package_category.description
          this.short_description = this.package_category.short_description
          this.button_text = this.package_category.button_text
          this.image_url = this.package_category.image_url
          this.meta = this.package_category.meta
        }
        else {
          this.name = null
          this.visible = true
          this.description = null
          this.short_description = null
          this.button_text = null
          this.image_url = null
          this.meta = null
        }
        this.visible = true
      },
      onHidden() {
        this.visible = false
        this.busy = false
        this.error = null
      },
    },
    mounted() {
      window.packageCategoryModal = this
    },
  }
</script>